import { render, staticRenderFns } from "./InfoSection.vue?vue&type=template&id=316a9b2a"
import script from "./InfoSection.vue?vue&type=script&lang=ts"
export * from "./InfoSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('316a9b2a')) {
      api.createRecord('316a9b2a', component.options)
    } else {
      api.reload('316a9b2a', component.options)
    }
    module.hot.accept("./InfoSection.vue?vue&type=template&id=316a9b2a", function () {
      api.rerender('316a9b2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/CarePlanRightSide/components/InfoSection.vue"
export default component.exports